import { Dropdown } from 'primereact/dropdown';
import { SyntheticEvent } from 'react';

import { Status } from '@shared/types/common';

export const FieldTypes = {
  ADVERTISER: 'advertiserId',
  BRAND: 'brandId',
  BILLING_CONTACT: 'billingContactId',
  BUDGET: 'budget',
  DATERANGE: 'dateRange',
  AGENCY_COMMISSION: 'isAgencyCommissionGross',
  CAMPAIGN_NAME: 'name',
  IS_NAME_AUTOGENERATED: 'isNameAutoGenerated',
  FORMAT_TYPE_VIDEO: 'formatTypeVideo',
  FORMAT_TYPE_DISPLAY: 'formatTypeDisplay',
  IS_CREATIVE_SERVICES_FULL: 'isCreativeServicesFull',
  NUMBER_OF_CREATIVES: 'numberOfCreatives',
  VIDEO_PRODUCTS_LINEAR_ADDRESSABLE: 'videoProductsLinearAddressable',
  CREATIVE_L_SHAPED_IMAGE: 'creativeImageLShaped',
  CREATIVE_LANDING_IMAGE: 'creativeImageLanding',
  CREATIVE_VIDEO_SPOT: 'creativeVideoSpot',
  CREATIVE_VIDEO_SPOT_STATUS: 'creativeVideoSpotStatus',
  CREATIVE_SWITCH_IN_LEFT: 'creativeSwitchInLeft',
  CREATIVE_SWITCH_IN_BOTTOM: 'creativeSwitchInBottom',
  CREATIVE_INTRO_MOBILE_IMAGE: 'creativeImageIntroMobile',
  CREATIVE_MASTHEAD_IMAGE: 'creativeImageMasthead',
  CREATIVE_MASTHEAD_ADAPTIVE_IMAGE: 'creativeImageMastheadAdaptive',
  CREATIVE_SKIN_IMAGE: 'creativeImageSkin',
  TRACKING_URL: 'trackingUrl',
  LANDING_PAGE_URL: 'landingPageUrl',
  CONTENT_PACKAGE: 'contentPackage',
  THEMATIC_PACKAGE_ID: 'thematicPackageId',
  PROVINCES: 'provinces',
  CITIES: 'cities',
  AGE_AND_GENDER: 'ageGender',
  INTEREST_SEGMENTS: 'interestSegments',
  CONTENT_PACKAGE_OPERATION_TYPE: 'contentPackageOperationType',
  INTEREST_SEGMENTS_OPERATION_TYPE: 'interestSegmentsOperationType',
  AGE_AND_GENDER_OPERATION_TYPE: 'ageAndGenderOperationType',
  PROVINCES_OPERATION_TYPE: 'provincesOperationType',
  IMPRESSIONS: 'impressions',
  BONUS_IMPRESSIONS: 'bonusImpressions',
  BONUS_IMPRESSIONS_TOGGLE: 'bonusImpressionsToggle',
  CPM: 'cpm',
  ADDITIONAL_NOTE: 'additionalNote',
  BONUS_PRICE: 'bonusPrice',
  INVENTORY: 'inventory',
  VIDEO_CONTAINS_POLITICAL_CONTENT: 'videoContainsPoliticalContent',
  LSHAPE_CONTAINS_POLITICAL_CONTENT: 'lShapeContainsPoliticalContent',
  LANDING_CONTAINS_POLITICAL_CONTENT: 'landingContainsPoliticalContent',
  SWITCH_IN_LEFT_CONTAINS_POLITICAL_CONTENT: 'switchInLeftContainsPoliticalContent',
  SWITCH_IN_BOTTOM_CONTAINS_POLITICAL_CONTENT: 'switchInBottomContainsPoliticalContent',
  INTRO_MOBILE_CONTAINS_POLITICAL_CONTENT: 'introMobileContainsPoliticalContent',
  MASTHEAD_CONTAINS_POLITICAL_CONTENT: 'mastheadContainsPoliticalContent',
  MASTHEAD_ADAPTIVE_CONTAINS_POLITICAL_CONTENT: 'mastheadAdaptiveContainsPoliticalContent',
  SKIN_CONTAINS_POLITICAL_CONTENT: 'skinContainsPoliticalContent',
} as const;

export type FormatTypeFields = typeof FieldTypes.FORMAT_TYPE_VIDEO | typeof FieldTypes.FORMAT_TYPE_DISPLAY;

export const FieldOperationType = {
  INCLUDE: 'INCLUDE',
  EXCLUDE: 'EXCLUDE',
} as const;

export interface DropdownItem {
  name: string;
  value: string;
  code?: string;
  disabled: boolean;
  showCode?: boolean;
  nameWithCode?: `${string} (${string})`;
  status?: Status;
}

export type EnhancedDropdown = Dropdown & { show: () => void };

export interface PreviewCreativeModalOptions {
  rejectImageCallback: (event: SyntheticEvent) => void;
  rejectTranslationKey: string;
  acceptImageCallback: () => void;
}

export interface SwitchInPreviewModalOptions {
  rejectLeftImageCallback: (event: SyntheticEvent) => void;
  rejectBottomImageCallback: (event: SyntheticEvent) => void;
  acceptImageCallback: () => void;
}
